import { cn } from '@/lib/utils';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ILoad } from '../../models';

interface IProps {
  load: ILoad | null;
  isLoad?: boolean;
}

export const AnalysisGrainData: FC<IProps> = ({ load, isLoad = false }) => {
  const { t } = useTranslation();

  const list = useMemo(() => {
    return [
      {
        title: t('humidity'),
        value: load?.humidity ? load?.humidity + '%' : '---',
      },
      {
        title: t('pollution'),
        value: load?.pollution ? load?.pollution + '%' : '---',
      },
      {
        title: t('natura'),
        value: load?.natura ? load?.natura + '%' : '---',
      },
      {
        title: t('grain.mixture'),
        value: load?.grain_mixture ? load?.grain_mixture + '%' : '---',
      },
      {
        title: t('grain.gluten'),
        value: load?.kleykovina ? load?.kleykovina + '%' : '---',
      },
      {
        title: t('grain.vitreous'),
        value: load?.steklovidnost ? load?.steklovidnost + '%' : '---',
      },
      {
        title: t('industrial.grade'),
        value: load?.grain_class || '---',
      },
    ];
  }, [load]);

  return (
    <div className={'grid grid-cols-5 w-full gap-4'}>
      {list?.map((field) => {
        return (
          <div key={field.title}>
            <p className="text-sm text-gray-600 mb-2">{field.title}:</p>
            <p className={(cn('text-base'), isLoad ? 'font-medium' : '')}>
              {field.value}
            </p>
          </div>
        );
      })}
    </div>
  );
};
